import type { StaffRole } from "./model";

/** A partner's own queue can say "Me"; the admin sees the responsible team. */
export function staffOwnerLabel(
  owner: "partner" | "client" | "alex",
  role: StaffRole,
  partnerName: string | null | undefined,
  t: (key: string) => string
): string {
  if (owner === "partner" && role === "admin") {
    return partnerName?.trim()
      ? t("staffConsole.onDeckWho.assigned").replace("{name}", partnerName.trim())
      : t("staffConsole.onDeckWho.team");
  }
  return t(`staffConsole.onDeckWho.${owner}`);
}
